// View-only: selecting a time never books.
import { Button, Stack } from '@mui/material';
import type React from 'react';
import { formatSlotTime } from './memberPreviewCalendar';
import type { MemberPreviewSlot } from './memberPreviewTypes';

interface MemberPreviewTimeListProps {
  slots: MemberPreviewSlot[];
  timeZone: string;
  selectedStart: string | null;
  onSelect: (startAt: string) => void;
}

const MemberPreviewTimeList: React.FC<MemberPreviewTimeListProps> = ({ slots, timeZone, selectedStart, onSelect }) => (
  <Stack spacing={1} role="listbox" aria-label="Available times">
    {slots.map((slot) => (
      <Button
        key={slot.start_at}
        role="option"
        aria-selected={slot.start_at === selectedStart}
        variant={slot.start_at === selectedStart ? 'contained' : 'outlined'}
        onClick={() => onSelect(slot.start_at)}
      >
        {formatSlotTime(slot.start_at, timeZone)}
      </Button>
    ))}
  </Stack>
);

export default MemberPreviewTimeList;
